(function () {

    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {

        $stateProvider.state(
            'tat-dashboard',
            {

                parent: 'app',

                url: '/tat-dashboard',

                data: {
                    authorities: [],
                    pageTitle: 'global.menu.tat-dashboard'

                },

                views: {

                    'content@': {

                        templateUrl:
                            'app/tat-dashboard/tat-dashboard.html',

                        controller:
                            'TatDashboardController',

                        controllerAs: 'vm'
                    }
                }
            }
        );
    }

})();
